import { View } from "./View";

export const ForgotPassword = () => {
  return <View />;
};
